// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tour_tooltip__xTsYD","tooltip-title":"Tour_tooltip-title__O4NmQ","tooltip-footer":"Tour_tooltip-footer__qZOvz"};